import { motion } from "framer-motion";
import { SmartImage } from "./SmartImage";
import { useApp } from "../context/AppContext";
import { useTranslation } from "../i18n";

// Six gallery slots (gallery-1 ... gallery-6) with a clean bento layout.
const SLOTS = [
  { slot: "gallery-1", span: "col-span-2 row-span-2" },
  { slot: "gallery-2", span: "col-span-1 row-span-1" },
  { slot: "gallery-3", span: "col-span-1 row-span-1" },
  { slot: "gallery-4", span: "col-span-1 row-span-2" },
  { slot: "gallery-5", span: "col-span-1 row-span-1" },
  { slot: "gallery-6", span: "col-span-1 row-span-1" },
  { slot: "gallery-7", span: "col-span-2 row-span-1" },
];

export const Gallery = () => {
  const { lang, hasImage } = useApp();
  const t = useTranslation(lang);
  return (
    <section id="gallery" data-testid="gallery-section" className="relative py-16 md:py-24 lg:py-36 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-14">
          <span className="overline">{t.gallery.overline}</span>
          <h2 className="font-serif-q5 text-4xl md:text-5xl mt-3 text-white">{t.gallery.title}</h2>
        </div>

        <div className="grid grid-cols-4 grid-rows-3 gap-3 md:gap-4 auto-rows-[180px] md:auto-rows-[220px]">
          {SLOTS.map((g, idx) => (
            <motion.div
              key={g.slot}
              data-testid={`gallery-img-${idx}`}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: idx * 0.06 }}
              className={`${g.span} overflow-hidden group border border-q5 hover:border-gold transition-colors relative`}
            >
              <SmartImage
                slot={g.slot}
                hasImage={hasImage(g.slot)}
                alt={`Galería ${idx + 1}`}
                className="w-full h-full"
                imgClassName="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
